import { render, staticRenderFns } from "./DSTabLine.vue?vue&type=template&id=38b8326f&scoped=true&"
import script from "./DSTabLine.vue?vue&type=script&lang=js&"
export * from "./DSTabLine.vue?vue&type=script&lang=js&"
import style0 from "./DSTabLine.vue?vue&type=style&index=0&id=38b8326f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b8326f",
  null
  
)

export default component.exports